import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api';
import { Ballot } from '../components/Ballot';
import { t } from '../i18n';

/** Terminumfrage über den persönlichen Link – ohne Konto, nur diese eine Umfrage. */
export function PublicPollPage() {
  const { token = '' } = useParams();
  const qc = useQueryClient();
  const ballot = useQuery({ queryKey: ['publicBallot', token], queryFn: () => api.publicBallot(token), retry: false });

  useEffect(() => {
    document.title = `${ballot.data?.title ?? t('polls.title')} · Kartothek`;
  }, [ballot.data?.title]);

  const head = (
    <div className="poll-public-head">
      <span className="logo">▤</span> {t('app.name')}
      {ballot.data?.campaignName && <span className="muted"> · {ballot.data.campaignName}</span>}
    </div>
  );

  if (ballot.isLoading) return <div className="center-screen muted">{t('common.loading')}</div>;
  if (ballot.isError || !ballot.data) {
    return (
      <div className="poll-public">
        {head}
        <div className="card">
          <p className="error">{t('polls.invalid')}</p>
        </div>
      </div>
    );
  }
  const b = ballot.data;
  return (
    <div className="poll-public">
      {head}
      <div className="card">
        <h1>{b.title}</h1>
        <p>{t('polls.hello', { name: b.displayName })}</p>
        <Ballot
          ballot={b}
          icsUrl={b.final ? api.publicIcsUrl(token) : undefined}
          onVote={async (slotId, answer, comment) => {
            const res = await api.castPublicBallot(token, slotId, answer, comment);
            qc.setQueryData(['publicBallot', token], res);
            return res;
          }}
        />
      </div>
    </div>
  );
}
